// extracted by mini-css-extract-plugin
module.exports = {"toast":"_2JMd_","toastIcon":"_1vBmw","text":"_1K5Tq","closeIcon":"_3zVa6","success":"D2G5S","error":"_1ophX","info":"_3B_Fm"};